module.exports = __webpack_public_path__ + "static/img/hand3.fadef2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hand3.png
// module id = tync
// module chunks = 208